import {
  Checkbox,
  Collapse,
  FormControlLabel,
  FormGroup,
} from '@material-ui/core';
import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown';
import { FiChevronUp } from '@react-icons/all-files/fi/FiChevronUp';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { FilterDialogContext } from '..';
import { makeSelectRefinementItemsByAttribute } from '~redux/search/product';
import { useProductSearchSelector } from '~view/widgets/ProductSearchProvider';

type RefinementListProps = {
  listId: string;
  header: string;
  attribute: string;
  listItems?: Record<string, string>;
};

const RefinementList: React.FC<RefinementListProps> = ({
  listId,
  header,
  attribute,
  listItems,
}) => {
  const [show, setShow] = useState(false);
  const { filters, setFilters } = useContext(FilterDialogContext);
  const refineItems = useProductSearchSelector(
    makeSelectRefinementItemsByAttribute(attribute),
    listId
  );
  const list = useMemo(() => {
    if (listItems) {
      return Object.entries(listItems).map(([label, value]) => ({
        label,
        value,
      }));
    }
    return refineItems.map((item) => ({
      label: item,
      value: item,
    }));
  }, [listItems, refineItems]);

  const selectedItems = useMemo(() => Object.keys(filters?.[attribute] ?? {}), [
    attribute,
    filters,
  ]);

  const handleCheck = useCallback(
    (checked, item) => {
      if (checked) {
        const newFilters = filters[attribute] ?? {};
        newFilters[item.label] = listItems?.[item.label];
        setFilters(attribute, newFilters);
        return;
      }
      delete filters[attribute][item.label];
      setFilters(attribute, filters[attribute]);
    },
    [attribute, listItems, filters]
  );

  if (!list?.length) {
    return null;
  }

  return (
    <div className="border-bottom mb-4">
      <h6 className="font-weight-bold">{header}</h6>
      <div>
        <FormGroup>
          {list.slice(0, 5).map((item) => (
            <FormControlLabel
              control={
                <Checkbox
                  name={attribute}
                  color="primary"
                  value={item.value}
                  checked={selectedItems.includes(item.label)}
                  onChange={(e) => handleCheck(e.currentTarget.checked, item)}
                />
              }
              label={item.label}
            />
          ))}
        </FormGroup>
        {list.length > 5 && (
          <>
            <Collapse in={show}>
              <FormGroup>
                {list.slice(5).map((item) => (
                  <FormControlLabel
                    control={<Checkbox name={attribute} color="primary" />}
                    label={item.label}
                    value={item.value}
                  />
                ))}
              </FormGroup>
            </Collapse>
            <button
              onClick={() => setShow((prev) => !prev)}
              className="border-0 bg-transparent font-weight-bold mb-4"
              style={{ textDecoration: 'underline' }}
            >
              {!show ? (
                <>
                  すべて表示
                  <FiChevronDown className="ml-2" />
                </>
              ) : (
                <>
                  閉じる
                  <FiChevronUp className="ml-2" />
                </>
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default RefinementList;
